import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

// ============================================
// LAZY LOADING - Carrega páginas sob demanda
// ============================================

// Authentication - Carregamento prioritário
const Login = lazy(() => import("../pages/authentication/Login"));
const Logout = lazy(() => import("../pages/authentication/Logout"));

// Dashboard - Alta prioridade (página inicial)
const Dashboard = lazy(() => import("../pages/dashboard/index"));
const TecnicoIndex = lazy(() => import("../pages/dashboard/tecnico"));

// Users
const UsersIndex = lazy(() => import("../pages/users/UsersIndex"));
const UsersShow = lazy(() => import("../pages/users/UsersShow"));
const UsersNew = lazy(() => import("../pages/users/UsersNew"));
const UsersEdit = lazy(() => import("../pages/users/UsersEdit"));
const IncomeUserEdit = lazy(() => import("../pages/users/income/IncomeUserEdit"));
const BankAccountEdit = lazy(() => import("../pages/users/bankAccount/BankAccountEdit"));
const AccountEdit = lazy(() => import("../pages/users/account/AccountEdit"));

// Contracts
const ContractsIndex = lazy(() => import("../pages/contracts/ContractsIndex"));
const ContractsShow = lazy(() => import("../pages/contracts/ContractShow"));
const ContractsEdit = lazy(() => import("../pages/contracts/ContractsEdit"));
const ContractualEdit = lazy(() => import("../pages/contracts/ContractualEdit"));
const ContractualEditShow = lazy(() => import("../pages/contracts/ContractualEditShow"));
const ContractsTermination = lazy(() => import("../pages/contracts/ContractsTermination"));
const ContractRestore = lazy(() => import("../pages/contracts/ContractRestore"));
const UpdateCommissions = lazy(() => import("../pages/contracts/UpdateCommissions"));
const ContractsConfirmTermination = lazy(() => import("../pages/contracts/ContractsConfirmTermination"));
const FriendlyAgreement = lazy(() => import("../pages/contracts/FriendlyAgreement"));
const SendExtrajudicialNotice = lazy(() => import("../pages/contracts/SendExtrajudicialNotice"));
const ProfileRevalidation = lazy(() => import("../pages/contracts/ProfileRevalidation"));

// Billing
const BillingShow = lazy(() => import("../pages/billing/BillingShow"));
const BillingEdit = lazy(() => import("../pages/billing/BillingEdit"));
const BillingReembolsoShow = lazy(() => import("../pages/billing/BillingReembolsoShow"));
const WebhookErrorShow = lazy(() => import("../pages/billing/WebhookErrorShow"));

// Central billings
const BillingCreateCentral = lazy(() => import("../pages/billing/central-billings/BillingCreate"));

// Announcements
const AnnouncementsIndex = lazy(() => import("../pages/announcements/AnnouncementsIndex"));
const AnnouncementsShow = lazy(() => import("../pages/announcements/AnnouncementsShow"));
const AnnouncementsEdit = lazy(() => import("../pages/announcements/AnnouncementsEdit"));

// Crawler
const CrawlerIndex = lazy(() => import("../pages/crawler/CrawlerIndex"));
const CrawlerShow = lazy(() => import("../pages/crawler/CrawlerShow"));
const CrawlerEdit = lazy(() => import("../pages/crawler/CrawlerEdit"));

// Crawler Config
const CrawlerConfigIndex = lazy(() => import("../pages/crawlerConfig/crawlerConfigIndex"));
const CrawlerConfigShow = lazy(() => import("../pages/crawlerConfig/crawlerConfigShow"));
const CrawlerConfigEdit = lazy(() => import("../pages/crawlerConfig/crawlerConfigEdit"));
const CrawlerConfigNew = lazy(() => import("../pages/crawlerConfig/crawlerConfigNew"));
const HSMConfig = lazy(() => import("../pages/crawlerConfig/HSMConfig"));
const SMSConfig = lazy(() => import("../pages/crawlerConfig/SMSConfig"));

// Public Links
const PublicLinksShow = lazy(() => import("../pages/publicLinks/PublicLinksShow"));
const PublicLinksIndex = lazy(() => import("../pages/publicLinks/PublicLinksIndex"));

// Vouchers
const VouchersIndex = lazy(() => import("../pages/vouchers/VouchersIndex"));
const VouchersNew = lazy(() => import("../pages/vouchers/VouchersNew"));
const VouchersShow = lazy(() => import("../pages/vouchers/VouchersShow"));

// Notifications
const NotificationsIndex = lazy(() => import("../pages/notifications/NotificationsIndex"));
const NotificationsShow = lazy(() => import("../pages/notifications/NotificationsShow"));
const NotificationTemplatesIndex = lazy(() => import("../pages/notifications/NotificationTemplatesIndex"));
const NotificationTemplatesEdit = lazy(() => import("../pages/notifications/NotificationTemplatesEdit"));

// Negotiation
const NegotiationIndex = lazy(() => import("../pages/negotiation/NegotiationIndex"));
const NegotiationNew = lazy(() => import("../pages/negotiation/NegotiationNew"));
const NegotiationShow = lazy(() => import("../pages/negotiation/NegotiationShow"));
const NegotiationEdit = lazy(() => import("../pages/negotiation/NegotiationEdit"));
const NegotiationLaudo = lazy(() => import("../pages/negotiation/NegotiationLaudo"));
const NegotiationLaudoHistorico = lazy(() => import("../pages/negotiation/NegotiationLaudoHistorico"));
const NegotiationLaudoInquilino = lazy(() => import("../pages/negotiation/NegotiationLaudoInquilino"));
const OcorrenciaShow = lazy(() => import("../pages/negotiation/OcorrenciaShow"));
const NegotiationLaudoAddTenant = lazy(() => import("../pages/negotiation/NegotiationLaudoAddTenant"));
const NegotiationLaudoEditTenant = lazy(() => import("../pages/negotiation/NegotiationLaudoEditTenant"));

// Transfers
const TransferShow = lazy(() => import("../pages/transfers/TransferShow"));

// Affiliate - Comentado pois não está sendo usado nas rotas
// const AffiliateIndex = lazy(() => import("../pages/affiliate/AffiliateIndex"));

// Error Pages
const ErrorPage1 = lazy(() => import("../pages/errors/ErrorPage1"));
const ErrorPage2 = lazy(() => import("../pages/errors/ErrorPage2"));
const ErrorPage3 = lazy(() => import("../pages/errors/ErrorPage3"));

// Chat
const Chat = lazy(() => import("../pages/chat/Chat"));

// Templates
const TemplateIndex = lazy(() => import("../pages/Templates/TemplateIndex"));
const TemplateSMSShow = lazy(() => import("../pages/Templates/sms/smsShow"));
const TemplateSMSEdit = lazy(() => import("../pages/Templates/sms/smsEdit"));

// Gerador Contrato
const GeradorContratoIndex = lazy(() => import("../pages/geradorcontrato/GeradorContratoIndex"));
const GeradorContratoEdit = lazy(() => import("../pages/geradorcontrato/GeradorContratoEdit"));

// Pagamento
const CobrancaIndex = lazy(() => import("../pages/pagamento/cobranca/CobrancaIndex"));
const ReguasIndex = lazy(() => import("../pages/pagamento/cobranca/ReguasIndex"));
const NegativacaoIndex = lazy(() => import("../pages/pagamento/negativacao/NegativacaoIndex"));
const NegativacaoShow = lazy(() => import("../pages/pagamento/negativacao/NegativacaoShow"));
const IndicesIndex = lazy(() => import("../pages/pagamento/indices/IndicesIndex"));

// Gestão de recebíveis
const EmissoesIndex = lazy(() => import("../pages/recebiveis/emissoes/EmissoesIndex"));
const EmissoesCreate = lazy(() => import("../pages/recebiveis/emissoes/EmissoesCreate"));
const EmissoesEdit = lazy(() => import("../pages/recebiveis/emissoes/EmissoesEdit"));
const EmissoesShow = lazy(() => import("../pages/recebiveis/emissoes/EmissoesShow"));
const RemessaShow = lazy(() => import("../pages/recebiveis/emissoes/remessas/RemessaShow"));
const RemessaCreate = lazy(() => import("../pages/recebiveis/emissoes/remessas/RemessaCreate"));
const RetornoPreview = lazy(() => import("../pages/recebiveis/emissoes/remessas/RetornoPreview"));
const RetornoShow = lazy(() => import("../pages/recebiveis/emissoes/remessas/RetornoShow"));

const AcquisitionsIndex = lazy(() => import("../pages/recebiveis/cessoes-fidc/AquisitionsIndex"));
const AcquisitionsCreate = lazy(() => import("../pages/recebiveis/cessoes-fidc/AquisitionsCreate"));
const AcquisitionShow = lazy(() => import("../pages/recebiveis/cessoes-fidc/AcquisitionShow"));

const IntegralizationsIndex = lazy(() => import("../pages/recebiveis/integralizacoes-fidc/IntegralizationsIndex"));
const IntegralizationShow = lazy(() => import("../pages/recebiveis/integralizacoes-fidc/IntegralizationShow"));
const IntegralizationsCreate = lazy(() => import("../pages/recebiveis/integralizacoes-fidc/IntegralizationsCreate"));

// Relatórios
const RelatoriosIndex = lazy(() => import("../pages/recebiveis/relatorios/RelatoriosIndex"));
const AcquisitionReportsIndex = lazy(() => import("../pages/acquisition-reports/AcquisitionReportsIndex"));

// Property Inspection
const PropertyInspectionShow = lazy(() => import("../pages/property-inspection/PropertyInspectionShow"));
const PropertyInspectionIndex = lazy(() => import("../pages/property-inspection/PropertyInspectionIndex"));
const PropertyInspectionEdit = lazy(() => import("../pages/property-inspection/PropertyInspectionEdit"));

// Coupons
const CouponsIndex = lazy(() => import("../pages/coupons/CouponsIndex"));
const CouponsNew = lazy(() => import("../pages/coupons/CouponsNew"));
const CouponsShow = lazy(() => import("../pages/coupons/CouponsShow"));
const CouponsEdit = lazy(() => import("../pages/coupons/CouponsEdit"));

// Feature Flags
const FeatureFlagsIndex = lazy(() => import("../pages/feature-flags/FeatureFlagsIndex"));
const FeatureFlagsNew = lazy(() => import("../pages/feature-flags/FeatureFlagsNew"));
const FeatureFlagsShow = lazy(() => import("../pages/feature-flags/FeatureFlagsShow"));
const FeatureFlagsEdit = lazy(() => import("../pages/feature-flags/FeatureFlagsEdit"));

// Banners
const BannersIndex = lazy(() => import("../pages/banners/BannersIndex"));
const BannersNew = lazy(() => import("../pages/banners/BannersNew"));
const BannersShow = lazy(() => import("../pages/banners/BannersShow"));
const BannersEdit = lazy(() => import("../pages/banners/BannersEdit"));

// Doc Users
const docUserShow = lazy(() => import("../pages/doc-users/docUserShow"));
const docUserIndex = lazy(() => import("../pages/doc-users/docUserIndex"));

// Friendly Agreement
const friendlyAgreementIndex = lazy(() => import("../pages/friendly-agreement/friendlyAgreementIndex"));

// Análise Financeira
const AnaliseIndex = lazy(() => import("../pages/analise-financeira/AnaliseIndex"));
const PreAnaliseIndex = lazy(() => import("../pages/pre-analise-financeira/PreAnaliseIndex"));
const PreAnaliseLaudo = lazy(() => import("../pages/pre-analise-financeira/PreAnaliseLaudo"));

// Gratificações
const GratificationIndex = lazy(() => import("../pages/pagamento/gratifications/GratificationIndex"));
const GratificationCreate = lazy(() => import("../pages/pagamento/gratifications/GratificationCreate"));
const GratificationShow = lazy(() => import("../pages/pagamento/gratifications/GratificationShow"));
const GratificationEdit = lazy(() => import("../pages/pagamento/gratifications/GratificationEdit"));

// Antecipações
const NewAnticipation = lazy(() => import("../pages/users/anticipations/NewAnticipation"));
const AnticipationShow = lazy(() => import("../pages/users/anticipations/AnticipationShow"));
const AnticipationsIndex = lazy(() => import("../pages/pagamento/anticipations/AnticipationsIndex"));

const authProtectedRoutes = [
	{ path: "/dashboard", component: Dashboard },
	{ path: "/dashboard-tecnico", component: TecnicoIndex },

	// Users
	{ path: "/users/index", component: UsersIndex },
	{ path: "/users/show/:id", component: UsersShow },
	{ path: "/users/edit/:id", component: UsersEdit },
	{ path: "/users/new", component: UsersNew },

	// Income User
	{ path: "/users/income/:id", component: IncomeUserEdit },

	// Bank Account
	{ path: "/bank-account/edit/:id", component: BankAccountEdit },

	// Account
	{ path: "/account/edit/:id", component: AccountEdit },

	// Contracts
	{ path: "/contracts/index", component: ContractsIndex },
	{ path: "/contracts/show/:id", component: ContractsShow },
	{ path: "/contracts/edit/:id", component: ContractsEdit },
	{ path: "/contracts/contractual-edit/:id", component: ContractualEdit },
	{ path: "/show/contractual-edit/:id", component: ContractualEditShow },
	{ path: "/contracts/termination/:id", component: ContractsTermination },
	{ path: "/contracts/termination-confirm/:id", component: ContractsConfirmTermination },
	{ path: "/contracts/restore/:id", component: ContractRestore },
	{ path: "/contracts/friendly-agreement/:id", component: FriendlyAgreement },
	{ path: "/contracts/editar-comissoes/:id", component: UpdateCommissions },
	{ path: "/contracts/extrajudicial-notice/:id", component: SendExtrajudicialNotice },
	{ path: "/contracts/profile-revalidation/:id", component: ProfileRevalidation },

	// Analises
	{ path: "/analise/index", component: AnaliseIndex },
	{ path: "/pre-analise/index", component: PreAnaliseIndex },
	{ path: "/pre-analise/laudo/:id", component: PreAnaliseLaudo },
	// { path: "/Analise/show/:id", component: AnaliseShow },

	// Billing
	{ path: "/billing/edit/:id", component: BillingEdit },
	{ path: "/billing/reembolso/show/:id", component: BillingReembolsoShow },
	{ path: "/billing/show/:id", component: BillingShow },
	{ path: "/webhook-error/show/:id", component: WebhookErrorShow },

	// Central billings
	{ path: "/billing/create/:id", component: BillingCreateCentral },


	// Announcements
	{ path: "/announcements/index", component: AnnouncementsIndex },
	{ path: "/announcements/show/:id", component: AnnouncementsShow },
	{ path: "/announcements/edit/:id", component: AnnouncementsEdit },

	// Crawler
	{ path: "/crawler/index", component: CrawlerIndex },
	{ path: "/crawler/show/:id", component: CrawlerShow },
	{ path: "/crawler/edit/:id", component: CrawlerEdit },

	// Crawler Config
	{ path: "/crawlerConfig/index", component: CrawlerConfigIndex },
	{ path: "/crawlerConfig/show/:name", component: CrawlerConfigShow },
	{ path: "/crawlerConfig/edit/:name", component: CrawlerConfigEdit },
	{ path: "/crawlerConfig/new", component: CrawlerConfigNew },
	{ path: "/crawlerConfig/hsm", component: HSMConfig },
	{ path: "/crawlerConfig/sms", component: SMSConfig },

	// Public Links
	{ path: "/public-links/index", component: PublicLinksIndex },
	{ path: "/public-links/show/:id", component: PublicLinksShow },

	// Public Links
	{ path: "/gerador-contrato/index", component: GeradorContratoIndex },
	{ path: "/gerador-contrato/edit/:id", component: GeradorContratoEdit },

	// Vouchers
	{ path: "/vouchers/index", component: VouchersIndex },
	{ path: "/vouchers/show/:id", component: VouchersShow },
	{ path: "/vouchers/new", component: VouchersNew },

	// Notifications
	{ path: "/notifications/index", component: NotificationsIndex },
	{ path: "/notifications/show/:id", component: NotificationsShow },
	{ path: "/notifications/templates", exact: true, component: NotificationTemplatesIndex },
	{ path: "/notifications/templates/:id", component: NotificationTemplatesEdit },

	// Negotiation
	{ path: "/negotiation/index", component: NegotiationIndex },
	{ path: "/negotiation/new", component: NegotiationNew },
	{ path: "/negotiation/show/:id", component: NegotiationShow },
	{ path: "/negotiation/edit/:id", component: NegotiationEdit },
	{ path: "/negotiation/laudo/inquilino/:id/:inquilinoId", component: NegotiationLaudoInquilino },
	{ path: "/negotiation/laudo/addtenant/:id", component: NegotiationLaudoAddTenant },
	{ path: "/negotiation/laudo/:id/tenant/:tenantId", component: NegotiationLaudoEditTenant },
	{ path: "/negotiation/laudo/historico/:id", component: NegotiationLaudoHistorico },
	{ path: "/negotiation/laudo/:id", component: NegotiationLaudo },

	// Ocorrencias
	{ path: "/ocorrencias/show/:id/:negotiationId", component: OcorrenciaShow },


	// Affiliate
	// { path: "/affiliate/index", component: AffiliateIndex },

	// Chat
	{ path: "/chat", component: Chat },

	// Pagamento
	{ path: "/pagamento/cobrancas/index", component: CobrancaIndex },
	{ path: "/pagamento/cobrancas/reguas", component: ReguasIndex },

	{ path: "/pagamento/negativacao/index", component: NegativacaoIndex },
	{ path: "/pagamento/negativacao/show/:id", component: NegativacaoShow },

	// Error
	{ path: "/error/error-v1", component: ErrorPage1 },
	{ path: "/error/error-v2", component: ErrorPage2 },
	{ path: "/error/error-v3", component: ErrorPage3 },

	//template
	{ path: "/templates/index", component: TemplateIndex },
	{ path: "/templates/sms/show/:id", component: TemplateSMSShow },
	{ path: "/templates/sms/edit/:id", component: TemplateSMSEdit },

	// Pagamento
	// { path: "/pagamento/historico/index", component: HistoricoIndex },
	{ path: "/pagamento/cobrancas/index", component: CobrancaIndex },
	{ path: "/pagamento/cobrancas/reguas", component: ReguasIndex },

	// Property Inspection
	{ path: "/property-inspection/show/:id", component: PropertyInspectionShow },
	{ path: "/contracts/property-inspection/show/:id", component: PropertyInspectionIndex },
	{ path: "/contracts/property-inspection/edit/:id", component: PropertyInspectionEdit },

	// Cupons
	{ path: "/coupons/index", component: CouponsIndex },
	{ path: "/coupons/new", component: CouponsNew },
	{ path: "/coupons/show/:id", component: CouponsShow },
	{ path: "/coupons/edit/:id", component: CouponsEdit },

	// Feature Flags
	{ path: "/feature-flags/index", component: FeatureFlagsIndex },
	{ path: "/feature-flags/new", component: FeatureFlagsNew },
	{ path: "/feature-flags/show/:id", component: FeatureFlagsShow },
	{ path: "/feature-flags/edit/:id", component: FeatureFlagsEdit },

	// Banners
	{ path: "/banners/index", component: BannersIndex },
	{ path: "/banners/new", component: BannersNew },
	{ path: "/banners/show/:id", component: BannersShow },
	{ path: "/banners/edit/:id", component: BannersEdit },

	//Indices
	{ path: "/pagamento/indices/index", component: IndicesIndex },

	// Recebíveis
	{ path: "/recebiveis/emissoes/index", component: EmissoesIndex },
	{ path: "/recebiveis/emissoes/create", component: EmissoesCreate },
	{ path: "/recebiveis/emissoes/edit", component: EmissoesEdit },
	{ path: "/recebiveis/emissoes/show/:id", component: EmissoesShow },
	{ path: "/recebiveis/emissoes/remessa/show/:id", component: RemessaShow },
	{ path: "/recebiveis/emissoes/remessa/create", component: RemessaCreate },
	{ path: "/recebiveis/emissoes/retorno/preview/:id", component: RetornoPreview },
	{ path: "/recebiveis/emissoes/retorno/show/:id", component: RetornoShow },

	// Relatórios
	{ path: "/recebiveis/relatorios", component: RelatoriosIndex },
	{ path: "/acquisition-reports/index", component: AcquisitionReportsIndex },

	// Cessões / FIDC
	{ path: "/recebiveis/cessoes-fidc/aquisicao/show/:id", component: AcquisitionShow },
	{ path: "/recebiveis/cessoes-fidc/aquisicao/new", component: AcquisitionsCreate },
	{ path: "/recebiveis/cessoes-fidc", component: AcquisitionsIndex },

	// Integralizações
	{ path: "/recebiveis/integralizacoes-fidc/new", component: IntegralizationsCreate },
	{ path: "/recebiveis/integralizacoes-fidc/show/:id", component: IntegralizationShow },
	{ path: "/recebiveis/integralizacoes-fidc", component: IntegralizationsIndex },

	// Gratifications
	{ path: "/pagamento/gratificacao/index", component: GratificationIndex },
	{ path: "/pagamento/gratificacao/new", component: GratificationCreate },
	{ path: "/pagamento/gratificacao/show/:id", component: GratificationShow },
	{ path: "/pagamento/gratificacao/edit/:id", component: GratificationEdit },

	//
	{ path: "/doc-user/show/:id", component: docUserShow },
	{ path: "/doc-user/index", component: docUserIndex },

	//
	{ path: "/friendly-agreement/index", component: friendlyAgreementIndex },

	//
	{ path: "/anticipations/new/:id", component: NewAnticipation },
	{ path: "/anticipations/show/:id", component: AnticipationShow },
	{ path: '/pagamento/antecipacoes/index', component: AnticipationsIndex },

	//
	{ path: "/transfers/show/:id", component: TransferShow },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
];

export { authProtectedRoutes, publicRoutes };
